module.exports = __webpack_public_path__ + "img/pg3-film.c42331cb.jpg";